var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLockCardIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.95 9.031a.987.987 0 00-.663 1.729v.92a.662.662 0 101.325 0v-.92a.987.987 0 00-.663-1.729zm3.312-2.65V5.056a3.312 3.312 0 00-6.625 0v1.325A1.987 1.987 0 002.65 8.37v4.637a1.987 1.987 0 001.987 1.987h6.625a1.987 1.987 0 001.987-1.987V8.369a1.987 1.987 0 00-1.987-1.988zm-5.3-1.325a1.987 1.987 0 013.975 0v1.325H5.962V5.056zm5.962 7.95a.662.662 0 01-.662.662H4.637a.663.663 0 01-.662-.662V8.369a.662.662 0 01.662-.663h6.625a.662.662 0 01.662.663v4.637z",
    fill: "#9390A0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockCardIcon);
export default __webpack_public_path__ + "static/media/lock-card-icon.468eb1febeea4c793aeaa9138831b137.svg";
export { ForwardRef as ReactComponent };